import { render, staticRenderFns } from "./MerchantTest.vue?vue&type=template&id=0f58b359&scoped=true&"
import script from "./MerchantTest.vue?vue&type=script&lang=js&"
export * from "./MerchantTest.vue?vue&type=script&lang=js&"
import style0 from "./MerchantTest.scss?vue&type=style&index=0&id=0f58b359&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58b359",
  null
  
)

export default component.exports